<template>
  <div>
    <div class="widget-label">
      <div class="label">
        <p>
          Comments
          <span class="notice">{{ commentsCount }}</span>
        </p>
      </div>
      <!-- <div class="filter-select select-wrapper">
        <b-form-group label="Sort" label-cols label-for="sortComments" class>
          <b-form-select v-model="selection" id="sortComments" :options="options"></b-form-select>
        </b-form-group>
      </div> -->

      <div class="flex">
        <span>Show All</span>
        <b-form-checkbox
          v-model="showHidden"
          class="ml-2"
        >
        </b-form-checkbox>
      </div>
    </div>
    <div v-if="comments.length" class="widget-content">
      <b-row v-for="(type, i) in commentTypes" :key="type">
        <b-col cols="12">
          <p style="display: inline-block">{{ type }}</p>
          <b-button v-b-toggle="`accordion-${slugify(type)}`" class="accordion-btn" tag="div">
            <b-icon class="when-opened" icon="chevron-up"></b-icon>
            <b-icon class="when-closed" icon="chevron-down"></b-icon>
          </b-button>
        </b-col>

        <b-col cols="12">
          <transition>
            <b-collapse :id="`accordion-${slugify(type)}`">
              <b-row>
                <!-- Owner comments -->
                <b-col>
                  <ul class="comments-list">
                    <li
                      v-for="c in $options.filters.filteredComments(type, commentsOwners)"
                      v-bind:key="c.id"
                      class="list-item owner"
                      :class="commentStyle(c.questionType)"
                    >
                      {{ c.comment }}
                      <span>
                        {{ c.commentTitle ? c.commentTitle : `${c.questionText} | ${c.answerIndex} |` }}
                        <b-button
                          v-if="c.commentTitle == 'Safety Innovation' || c.commentTitle == 'Safety Opportunity'"
                          variant="link"
                          @click="onAddSafetyInnovation(c.comment)"
                        >
                          Add as Innovation
                        </b-button>
                        <b-button
                          v-else
                          variant="link"
                          @click="onAddAsProjectMetric(c.comment)"
                        >
                          Add as Action Item
                        </b-button>
                        <b-button v-if="c.commentHidden" variant="link" @click="unhideComment(c)">
                          Unhide
                        </b-button>
                        <b-button v-else variant="link" @click="hideComment(c)">
                          Hide
                        </b-button>
                        <b-button variant="link" @click="showDeleteConfirmation(c.id)">
                          Delete
                        </b-button>
                      </span>
                    </li>
                  </ul>
                </b-col>

                <!-- Contractor comments -->
                <b-col>
                  <ul class="comments-list">
                    <li
                      v-for="c in $options.filters.filteredComments(type, commentsContractors)"
                      v-bind:key="c.id"
                      class="list-item"
                      :class="commentStyle(c.questionType)"
                    >
                      {{ c.comment }}
                      <span>
                        {{ c.commentTitle ? c.commentTitle : `${c.questionText} | ${c.answerIndex} |` }}
                        <b-button
                          v-if="c.commentTitle === 'Safety Innovation' || c.commentTitle === 'Safety Opportunity'"
                          variant="link"
                          @click="onAddSafetyInnovation(c.comment)"
                        >
                          Add as Innovation
                        </b-button>
                        <b-button
                          v-else
                          variant="link"
                          @click="onAddAsProjectMetric(c.comment)"
                        >
                          Add as Action Item
                        </b-button>
                        <b-button v-if="c.commentHidden" variant="link" @click="unhideComment(c)">
                          Unhide
                        </b-button>
                        <b-button v-else variant="link" @click="hideComment(c)">
                          Hide
                        </b-button>
                        <b-button variant="link" @click="showDeleteConfirmation(c.id)">
                          Delete
                        </b-button>
                      </span>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </b-collapse>
          </transition>
        </b-col>

        <!-- Divider between types -->
        <b-col v-if="i < commentTypes.length - 1" cols="12">
          <hr>
        </b-col>
      </b-row>
    </div>
    
    <div v-else class="widget-content">No comments</div>
    <EditProjectMetricModal
      ref="add-project-metric-modal"
      :projectId="projectId"
      title="New Action Item"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Risk', 'Issue']"
      :presetTags="presetTags"
      @submit="onAddProjectMetricSubmit"
    />
    <EditProjectMetricModal
      ref="add-innovation-modal"
      :projectId="projectId"
      title="New Innovation"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Innovation']"
      :presetTags="presetTags"
      @submit="onAddProjectMetricSubmit"
    />
    <BaseConfirmationModal
      ref="del-comment-confirmation"
      message="Are you sure you want to delete this comment?"
      @submit="deleteComment"
      @cancel="cancelDelete"
    />
  </div>
</template>

<script>
import axios from "axios";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";

export default {
  name: "CommentList",
  components: {
    EditProjectMetricModal,
    BaseConfirmationModal
  },
  props: {
    comments: { type: Array, default: () => [] },
    periods: { type: Array, default: () => [] },
    defaultPeriod: { type: String, default: "" },
    projectId: { type: String, default: "" },
    projectUsers: { type: Array, default: () => [] },
    presetTags: { type: Array, default: () => [] },
    chartData: { type: Array, default: () => [] },
  },
  data() {
    return {
      selection: "",
      //options: ["Newest to Oldest","Oldest to Newest","Grade: Worst to Best","Grade: Best to Worst"],
      options: ["Grade: Worst to Best", "Grade: Best to Worst"],
      showHidden: false,
      deletingCommentId: "",
      // commentsCount: this.comments.length
    };
  },
  filters: {
    filteredComments(type, comments) {
      return comments.filter((c) => {
        if (c.questionType == 'Multiple Choice (Graded)') {
          return c.questionText == type;
        }
        return c.questionType == type;
      })
    },
  },
  methods: {
    onAddSafetyInnovation(description) {
      this.$refs["add-innovation-modal"].setDescription(description);
      this.$refs["add-innovation-modal"].show();
      this.$refs["add-innovation-modal"].addTag("Safety");
    },
    onAddAsProjectMetric(description) {
      this.$refs["add-project-metric-modal"].setDescription(description);
      this.$refs["add-project-metric-modal"].show();
    },
    onAddProjectMetricSubmit() {
      this.$emit("add");
    },
    hideComment(comment) {
      let index = this.comments.findIndex((c) => c.id == comment.id);
      this.$emit("hide", index);
    },
    unhideComment(comment) {
      let index = this.comments.findIndex((c) => c.id == comment.id);
      this.$emit("unhide", index);
    },
    showDeleteConfirmation(commentId) {
      this.deletingCommentId = commentId;
      this.$refs["del-comment-confirmation"].show();
    },
    cancelDelete() {
      this.deletingCommentId = "";
    },
    deleteComment() {
      let index = this.comments.findIndex((c) => c.id == this.deletingCommentId);
      this.$set(this.comments, index, {
        ...this.comments[index],
        commentHidden: true,
      });
      let url = `${this.$api_url}/survey/comments/delete/${this.deletingCommentId}/true`;
      axios
        .post(url, {}, this.getReqConfig())
        .then((res) => {
          console.log(res);
          this.deletingCommentId = "";
          this.commentsCount -= 1;
        })
        .catch((err) => console.log(err));
    },
    commentStyle(type) {
      let cls = "";
      if (type !== "Multiple Choice (Graded)") {
        cls += "important ";
      }
      if (type == "Safety Innovation") cls += "important--innovation";
      if (type == "Safety Opportunity") cls += "important--opportunity";

      return cls;
    },
    slugify(text) {
      return text.toLowerCase().replace(/\s+/g, '-')
    }
  },
  computed: {
    commentsCount() {
      return this.comments.length;
    },
    commentTypes() {
      let types = this.comments.filter(c => this.showHidden ? this.showHidden : !c.commentHidden).filter((comment, i, self) => {
        return (
          i ===
          self.findIndex((s) => {
            if (s.questionType == "Multiple Choice (Graded)")
              return s.questionText === comment.questionText;
            return s.questionType === comment.questionType;
          })
        );
      });

      return types
        .map((type) =>
          type.questionType == "Multiple Choice (Graded)"
            ? type.questionText
            : type.questionType
        )
        .sort((a, b) => {
          for (let i = 1; i < this.chartData.length; i++) {
            if (a == this.chartData[i][0] && b != this.chartData[i][0])
              return -1;
            if (a != this.chartData[i][0] && b == this.chartData[i][0])
              return 1;
            if (a == this.chartData[i][0] && b == this.chartData[i][0])
              return 0;
          }
        })
        .sort((a, b) => {
          if (a == "Safety Innovation") return -1;
          if (a == "Safety Opportunity") return -1;

          return 1;
        });
    },
    sortedComments() {
      let sorting = [...this.comments];
      switch (this.selection) {
        case "Newest to Oldest":
          return sorting.sort(function (a, b) {
            return a.periodDate < b.periodDate ? -1 : 1;
          });

        case "Oldest to Newest":
          return sorting.sort(function (a, b) {
            return a.periodDate > b.periodDate ? -1 : 1;
          });
          
        case "Grade: Worst to Best":
          return sorting.sort(function (a, b) {
            return a.answerIndex > b.answerIndex ? -1 : 1;
          });

        case "Grade: Best to Worst":
          return sorting.sort(function (a, b) {
            return a.answerIndex < b.answerIndex ? -1 : 1;
          });

        case "Grouped by type":
          return sorting.sort(function (a, b) {
            if (a.questionType === "Multiple Choice (Graded)") {
              if (a.questionText > b.questionText) return -1;
              if (a.questionText < b.questionText) return 1;
            }

            if (a.questionType > b.questionType) return 1;
            if (a.questionType < b.questionType) return -1;
          });

        default:
          return sorting;
      }
    },
    commentsOwners() {
      let owners = this.sortedComments.filter((comment) => {
        return comment.role == "Owner" && (this.showHidden || !comment.commentHidden);
      });

      owners.sort((a, b) => {
        if (a.questionType == "Multiple Choice (Graded)") return 1;
        if (
          a.questionType == "Safety Innovation" &&
          b.questionType != "Safety Innovation"
        )
          return -1;

        if (
          a.questionType == "Safety Opportunity" &&
          b.questionType != "Safety Innovation"
        )
          return -1;

        return 0;
      });
      return owners;
    },
    commentsContractors() {
      let contractors = this.sortedComments.filter((comment) => {
        return comment.role == "Contractor" && (this.showHidden || !comment.commentHidden);
      });

      contractors.sort((a, b) => {
        if (a.questionType == "Multiple Choice (Graded)") return 1;
        if (
          a.questionType == "Safety Innovation" &&
          b.questionType != "Safety Innovation"
        )
          return -1;

        if (
          a.questionType == "Safety Opportunity" &&
          b.questionType != "Safety Innovation"
        )
          return -1;

        return 0;
      });
      return contractors;
    },
  },
};
</script>
<style lang="scss" scoped>
.widget-content {
  p.label {
    color: #525456;
  }
  hr {
    margin: 24px 0 36px;
  }
}

.accordion-btn {
  background: transparent;
  color: #333;
  border: none;
  transition: color .3s ease;
  
  &:hover svg.b-icon {
    fill: #529ce3;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.comment {
  ul.comments-list {
    li.owner::before {
      color: #529ce3;
      color: var(--ct-blue);
    }
    li.important {
      border-radius: 10px;
      padding: 10px 5px 10px 40px;
      //margin-left: -10px;
      margin-bottom: 20px;
      background: rgba(0, 0, 0, 0.06);
      &--opportunity {
        background: rgba(52, 175, 249, 0.1);
      }
      &--innovation {
        background: rgba(52, 175, 249, 0.2);
      }
    }
  }
}

.collapse {
  max-height: 0;
  overflow: hidden;
  display: block !important;
  opacity: 0;
  transition: max-height .3s ease, opacity .5s ease;
  &.show {
    opacity: 1;
    max-height: 9999px;
    transition: max-height 1s ease 0s, opacity .3s ease;
  }
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
